import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class UserEditForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'userName',
					label: 'LOGINFORM.USERNAME',
					rules: 'required',
				},
				{
					name: 'email',
					label: 'LOGINFORM.EMAIL',
					rules: 'required|email|string|between:5,100',
				},
				{
					name: 'countryCodeId',
					label: 'LOGINFORM.COUNTRYCODE',
					rules: 'required',
				},
				{
					name: 'userPhone',
					label: 'LOGINFORM.USERPHONE',
					rules: 'required',
				},
				{
					name: 'roleIds',
					label: 'LOGINFORM.USERROLES.LABEL',
					placeholder: 'LOGINFORM.USERROLES.PLACEHOLDER',
					rules: 'required',
				},
				{
					name: 'apiKey',
					label: 'LOGINFORM.PRINTNODE.APIKEY',
				},
				{
					name: 'labelPrinterId',
					label: 'LOGINFORM.PRINTNODE.LABELPRINTER',
				},
				{
					name: 'packingSlipPrinterId',
					label: 'LOGINFORM.PRINTNODE.PACKINGSLIPPRINTER',
				},
				{
					name: 'upcLabelPrinterId',
					label: 'LOGINFORM.PRINTNODE.UPCLABELPRINTER',
				},
				{
					name: 'labelPrinterName',
					type: 'string',
				},
				{
					name: 'packingSlipPrinterName',
					type: 'string',
				},
				{
					name: 'upcLabelPrinterName',
					type: 'string',
				},
				{
					name: 'id',
					label: '',
				},
				{
					name: 'apiSecret',
					label: 'LOGINFORM.APISECRET',
				},
			],
		};
	}
}
